import React from 'react';
import { motion } from 'framer-motion';

interface LandingFaqProps {
  brandPrimary: string;
  brandCard: string;
  fadeInUp: any;
  staggerContainer: any;
}

export const LandingFaq: React.FC<LandingFaqProps> = ({
  brandPrimary,
  brandCard,
  fadeInUp,
  staggerContainer,
}) => {
  return (
    <section style={{ padding: '6rem 5%', maxWidth: '800px', margin: '0 auto' }}>
      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
        <h2 style={{ fontSize: '3rem', fontWeight: 800, marginBottom: '4rem', letterSpacing: '-0.03em', textAlign: 'center' }}>
          FAQs.
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {[
            {
              q: 'Can I store, stream, and share 4K videos?',
              a: 'Yes, absolutely! FileSharez supports MP4, MOV, and high-bitrate video clips up to full 4K UHD. Our streaming engine uses HTTP byte-range requests so videos play instantly in your browser or phone without waiting for the entire file to download.',
            },
            {
              q: 'How does FileSharez work for creative studios and businesses?',
              a: 'FileSharez provides client proofing galleries with star ratings, 1-click approvals, and photo comment threads. You can also generate Guest Upload links (dropboxes) allowing clients or event attendees to submit photos and videos straight into your account without needing to register.',
            },
            {
              q: 'Can team or family members keep their personal media private?',
              a: 'Yes! Every file and album can be toggled between "Shared with Account" (visible to all team or family members) and "Private (Only Me)". Private files and Personal Vaults are cryptographically scoped and locked behind a private PIN so other account users cannot view them.',
            },
            {
              q: 'How does the Semantic AI Search and Face Grouping work?',
              a: "When you upload media, our secure Edge AI scans visual contexts and creates semantic vector embeddings. You can search natural phrases like 'dog on the beach' or 'wedding cake', or tap any recognized face to see all matching media across your library.",
            },
            {
              q: 'Are there any egress bandwidth fees or download limits?',
              a: 'None! Powered by Cloudflare R2, FileSharez never penalizes you with data transfer fees. You can stream full-resolution media, download single files, or use our Direct Folder Takeout to stream 100GB+ libraries directly onto an external hard drive with zero unzipping.',
            },
            {
              q: 'Is there a free plan?',
              a: 'Yes! Every account starts on our Free plan with 2GB of storage and full access to AI search, video streaming, map heatmaps, and sharing. When you need more storage or team seats, upgrade to Personal, Family, Pro, or Studio at any time.',
            },
          ].map((faq, i) => (
            <motion.div
              key={i}
              variants={fadeInUp}
              style={{
                background: brandCard,
                padding: '2rem',
                borderRadius: '24px',
                border: '1px solid #E5E7EB',
                cursor: 'pointer',
                boxShadow: '0 4px 6px rgba(0,0,0,0.02)',
              }}
              onClick={(e) => {
                const el = e.currentTarget.querySelector('.answer');
                if (el) el.classList.toggle('hidden');
              }}
            >
              <div style={{ fontWeight: 700, fontSize: '1.2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {faq.q}
                <span style={{ color: brandPrimary, fontWeight: 900 }}>+</span>
              </div>
              <div className="answer hidden" style={{ marginTop: '1rem', color: '#6B7280', lineHeight: 1.6, fontWeight: 500, fontSize: '1.05rem' }}>
                {faq.a}
              </div>
            </motion.div>
          ))}
        </div>

        <style>{`
          .hidden { display: none !important; }
          html { scroll-behavior: smooth; }
        `}</style>
      </motion.div>
    </section>
  );
};
